module.exports = __webpack_public_path__ + "img/contenedores materias.9d475d3c.png";